<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Notifications</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer" style="max-width: 1400px;">
        <div class="view-item  position-relative">

          <div class="form-inner">
            <div class="form-header d-flex justify-content-between align-items-center">
              <h1 class="mb-0">{{ headerTitle }} Notifications</h1>
              <!-- <button type="button" class="form-close-button" @click="handleClose">
                                    &times;
                                </button> -->
            </div>

            <div class="form-body">
              <!-- Table Controls -->
              <div class="table-controls d-flex justify-content-between align-items-center">
                <div class="table-controls-left">
                  Show
                  <select class="form-select form-select-sm d-inline-block w-auto mx-1" v-model.number="pageLength">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                  Entries

                  <div class="search-box" style="max-width: 500px;">
                    <span class="material-symbols-outlined search-icon">search</span>
                    <input type="search" v-model="search" class="form-control form-control-sm pe-5 search-input"
                      placeholder="Search by message, sender, subject or status..." />
                  </div>
                </div>

                <div class="export-links d-flex">
                  <a href="#" class="export-link text-decoration-none" @click.prevent="exportToPDF()">Export to PDF</a>
                  <a href="#" class="export-link text-decoration-none" @click.prevent="exportToExcel()">Export to
                    Excel</a>
                </div>
              </div>

              <!-- Table -->
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Notification Message</th>
                      <th>Type</th>
                      <th>Description</th>
                      <th>Amount</th>
                      <th>Sender</th>
                      <th>Subject</th>
                      <th>Ticket Status</th>
                      <th>Ticket Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isLoading">
                      <td colspan="9" class="text-center py-3">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Loading notifications...
                      </td>
                    </tr>
                    <tr v-else-if="!paginatedItems.length">
                      <td :colspan="9" class="text-center text-muted py-4">
                        <div v-if="tableNotice">{{ tableNotice }}</div>
                        <div v-else>No notifications to display.</div>
                      </td>
                    </tr>
                    <tr v-else v-for="(notification, index) in paginatedItems" :key="index"
                      :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                      <td class="serial-no text-center">{{ (currentPage - 1) * pageLength + index + 1 }}</td>
                      <td class="primary-col text-start">
                        <router-link :to="getNotificationRoute(notification)"
                          class="view-link text-decoration-underline" @mouseenter="showTooltip($event, notification)"
                          @mouseleave="hideTooltip">
                          {{ notification.notificationMsg }}
                        </router-link>
                      </td>
                      <td class="secondary-col text-start">{{ notification.entityType || 'N/A' }}</td>
                      <td class="secondary-col text-start">{{ notification.description || 'N/A' }}</td>
                      <td class="secondary-col text-start">{{ formatCurrency(notification.amount || 0) ?? formatCurrency(notification.amountApproved || 0) ?? formatCurrency(notification.totalBudget || 0) ?? formatCurrency(notification.amtApproved || 0) }}</td>
                      <td class="secondary-col text-start">{{ notification.senderName || 'N/A' }}</td>
                      <td class="secondary-col text-start">{{ notification.subject || 'N/A' }}</td>
                      <td class="secondary-col text-start">{{ notification.ticketStatus || 'N/A' }}</td>
                      <td class="secondary-col text-start">{{ formatDate(notification.ticketTime) || 'N/A' }}</td>
                      <!-- <td class="text-center action">
                        <router-link :to="getNotificationRoute(notification)" class="btn btn-sm btn-primary">
                          View
                        </router-link>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Tooltip -->
              <div v-if="tooltipVisible && hoveredNotification" class="custom-tooltip" :style="{
                top: tooltipY + 'px',
                left: tooltipX + 'px'
              }">
                <div v-if="isLoadingDetails">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Loading details...
                </div>
                <div v-else>
                  <p><strong>Details</strong></p>
                  <!-- PV MEMO -->
                  <div v-if="hoveredNotification.entityType === 'PV_MEMO'">
                    <p><strong>File Title: </strong>{{ hoveredNotification.fileTitle || 'N/A' }}</p>
                    <p><strong>File Number: </strong>{{ hoveredNotification.fileNumber || 'N/A' }}</p>
                    <p><strong>MDA: </strong>{{ hoveredNotification.originatingMda || 'N/A' }}</p>
                    <p><strong>Amount Approved: </strong>{{ formatCurrency(hoveredNotification.amountApproved || 0) }}</p>
                    <p><strong>Org Code: </strong>{{ hoveredNotification.orgCode || 'N/A' }}</p>
                  </div>
                  <!-- PAYMENT VOUCHER -->
                  <div v-if="hoveredNotification.entityType === 'PV'">
                    <p><strong>PV Number: </strong>{{ hoveredNotification.pvNumber || 'N/A' }}</p>
                    <p><strong>Payee: </strong>{{ hoveredNotification.payee || 'N/A' }}</p>
                    <p><strong>MDA: </strong>{{ hoveredNotification.mdaName || 'N/A' }}</p>
                    <p><strong>Bank: </strong>{{ hoveredNotification.bankName || 'N/A' }}</p>
                    <p><strong>Gross Amount: </strong>{{ formatCurrency(hoveredNotification.grossAmount || 0) }}</p>
                    <p><strong>Warrant Number: </strong>{{ hoveredNotification.warrantNumber || 'N/A' }}</p>
                    <p><strong>PV Status: </strong>{{ hoveredNotification.pvStatus || 'N/A' }}</p>
                    <p><strong>Payment Type: </strong>{{ hoveredNotification.paymentType || 'N/A' }}</p>
                    <p><strong>Particulars: </strong>{{ hoveredNotification.particulars || 'N/A' }}</p>
                    <p><strong>Nature of Expenditure: </strong>{{ hoveredNotification.natureOfExpenditure || 'N/A' }}</p>
                    <p><strong>Org Code: </strong> {{ hoveredNotification.orgCode || 'N/A' }}</p>
                  </div>
                  <!-- MEMO -->
                  <div v-if="hoveredNotification.entityType === 'MEMO'">
                    <p><strong>File Title: </strong>{{ hoveredNotification.fileTitle || 'N/A' }}</p>
                    <p><strong>File Number: </strong>{{ hoveredNotification.fileNumber || 'N/A' }}</p>
                    <p v-if="hoveredNotification.pendingApproval"><strong>Old MDA: </strong>{{ hoveredNotification.oldOriginatingMda || 'N/A' }}</p>
                    <p><strong>MDA: </strong>{{ hoveredNotification.originatingMda || 'N/A' }}</p>
                    <p v-if="hoveredNotification.pendingApproval"><strong>Old Amount Approved: </strong>{{ formatCurrency(hoveredNotification.oldAmountApproved || 0) }}</p>
                    <p><strong>Amount Approved: </strong>{{ formatCurrency(hoveredNotification.amountApproved || 0) }}</p>
                    <p><strong>Org Code: </strong>{{ hoveredNotification.orgCode || 'N/A' }}</p>
                  </div>
                  <!-- APPRAISAL -->
                  <div v-if="hoveredNotification.entityType === 'APPRAISAL'">
                    <p><strong>MDA: </strong>{{ hoveredNotification.originatingMda || hoveredNotification.mda || 'N/A' }}</p>
                    <p><strong>Approval Authority: </strong>{{ hoveredNotification.approvalAuthority || hoveredNotification.approvalAuthorityName || 'N/A' }}</p>
                    <p><strong>Nature of Expenditure: </strong>{{ hoveredNotification.natureOfExpenditure || 'N/A' }}</p>
                    <p><strong>Purpose of Request: </strong>{{ hoveredNotification.purposeOfRequest || 'N/A' }}</p>
                    <p><strong>Amount Approved: </strong>{{ formatCurrency(hoveredNotification.amountApproved || hoveredNotification.amount || 0) }}</p>
                    <p><strong>Org Code: </strong>{{ hoveredNotification.orgCode || 'N/A' }}</p>
                    <!-- <p><strong>Balance:</strong> {{ formatCurrency(hoveredNotification.balance || 0) }}</p>
                    <p><strong>Performance:</strong> {{ Number(hoveredNotification.performance).toFixed(1) }}%</p>
                    <p><strong>Budget Year:</strong> {{ hoveredNotification.budgetYear }}</p>
                    <p><strong>Quarter:</strong> {{ hoveredNotification.quarter }}</p>
                    <p><strong>Approved Budget Amount:</strong> {{ formatCurrency(hoveredNotification.approvedBudgetAmount || 0) }}</p>
                    <p><strong>Amount Released To Date:</strong> {{ formatCurrency(hoveredNotification.amtReleasedToDate || 0) }}</p>
                    <p><strong>Approval Balance:</strong> {{ formatCurrency(hoveredNotification.approvalBalance || 0) }}</p> -->
                  </div>
                  <!-- BUDGET -->
                  <div v-if="hoveredNotification.entityType === 'BUDGET'">
                    <p><strong>File Name: </strong>{{ hoveredNotification.fileName || 'N/A' }}</p>
                    <p><strong>Budget Name: </strong>{{ hoveredNotification.budgetName || 'N/A' }}</p>
                    <p><strong>Budget Year: </strong>{{ hoveredNotification.year || 'N/A' }}</p>
                    <p><strong>Total Budget: </strong>{{ formatCurrency(hoveredNotification.totalBudget || 0) }}</p>
                  </div>
                  <!-- SPECIAL APPROVAL -->
                  <div v-if="hoveredNotification.entityType === 'SPECIAL_APPROVAL'">
                    <p><strong>File Number: </strong>{{ hoveredNotification.fileNumber || 'N/A' }}</p>
                    <p><strong>Purpose of Request: </strong>{{ hoveredNotification.purposeOfRequest || 'N/A' }}</p>
                    <p><strong>Nature of Expenditure: </strong>{{ hoveredNotification.natOfExpenditure || 'N/A' }}</p>
                    <p><strong>Amount Approved: </strong>{{ formatCurrency(hoveredNotification.amtApproved || 0) }}</p>
                    <p><strong>MDA: </strong>{{ hoveredNotification.originatingMda || 'N/A' }}</p>
                    <p><strong>Budget Year: </strong>{{ hoveredNotification.year || 'N/A' }}</p>
                    <p><strong>Total Budget: </strong>{{ formatCurrency(hoveredNotification.totalBudget || 0) }}</p>
                    <p><strong>Org Code: </strong>{{ hoveredNotification.orgCode || 'N/A' }}</p>
                  </div>
                </div>
              </div>

              <!-- Pagination Summary and Actions -->
              <div class="d-flex justify-content-between align-items-center">
                <small>
                  Showing {{ (currentPage - 1) * pageLength + 1 }} to
                  {{ Math.min(currentPage * pageLength, filteredItems.length) }} of
                  {{ filteredItems.length }} entries
                </small>

                <!-- Pagination Controls -->
                <nav>
                  <ul class="pagination d-flex pagination-sm justify-content-end mb-0">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <button class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</button>
                    </li>
                    <li v-for="page in getPageNumbers" :key="page" class="page-item"
                      :class="{ active: currentPage === page, disabled: page === '...' }">
                      <button class="page-link" href="#" @click.prevent="page !== '...' && changePage(page)">{{ page
                        }}</button>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <button class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from '../layout/DashboardLayout.vue';
import { useUserStore } from '@/stores/user'
import { debounce } from 'lodash'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import ExcelJS from 'exceljs'
import { useRoute } from 'vue-router'
import '@/assets/css/table.css'

dayjs.extend(utc)
dayjs.extend(timezone)

const notifications = ref([])
const isLoading = ref(false)
const isLoadingDetails = ref(false)
const search = ref('')
const pageLength = ref(10)
const currentPage = ref(1)
const root_api_url = process.env.VUE_APP_API_ROOT_URL
const route = useRoute()
const hoveredNotification = ref(null)
const tooltipVisible = ref(false)
const tooltipX = ref(0)
const tooltipY = ref(0)

const debouncedSearch = ref('')
watch(search, debounce((val) => {
  debouncedSearch.value = val
}, 300))

const userStore = useUserStore()
const userId = ref('')

// const allRoles = [
//   'qssu',
//   'dirOfBudget',
//   'perSec',
//   'commOfBAndP',
//   'registryOfficer',
//   'groupHead',
//   'groupMember',
//   'initiator',
// ]

// const checkRouteAccess = (routeRoles, profileRoles) => {
//   if (!routeRoles || routeRoles.length === 0) return true

//   const profile = profileRoles || {}

//   if (routeRoles.includes('')) {
//     const otherRoles = routeRoles.filter(role => role !== '')

//     if (otherRoles.some(role => profile?.[role])) return true

//     const isFreeUser = Object.keys(profile).every(
//       r => !allRoles.includes(r) || profile[r] === false
//     )
//     if (isFreeUser) return true

//     return false
//   }

//   return routeRoles.some(role => profile?.[role])
// }

watch(
  () => userStore.profile?.id,
  (newId) => {
    if (newId) {
      userId.value = newId
    }
  },
  { immediate: true }
)

watch(userId, (newId) => {
  if (newId) {
    getNotifications()
  }
})

watch(
  () => [
    route.params?.entityType,
    route.params?.statusInd,
    route.query?.entityType,
    route.query?.statusInd,
  ],
  () => {
    if (userId.value) {
      getNotifications()
    }
  }
)

const headerTitle = computed(() => {
  let entityType = route.params?.entityType ?? route.query?.entityType
  const statusInd = route.params?.statusInd ?? route.query?.statusInd

  if (entityType && statusInd) {
    if (entityType === 'PV_MEMO') {
      entityType = 'PV Memo'
    }
    if (entityType === 'PV') {
      entityType = 'Payment Voucher'
    }
    if (entityType === 'MEMO') {
      entityType = 'Memo'
    }
    if (entityType === 'APPRAISAL') {
      entityType = 'Appraisal'
    }
    if (entityType === 'BUDGET') {
      entityType = 'Budget'
    }
    if (entityType === 'SPECIAL_APPROVAL') {
      entityType = 'Special Approval'
    }
    return `${entityType}`
  }
  return 'Pending Notifications'
})

const showTooltip = async (event, notification) => {
  hoveredNotification.value = notification
  tooltipVisible.value = true

  const rect = event.currentTarget.getBoundingClientRect()

  tooltipX.value = rect.left + window.scrollX
  tooltipY.value = rect.bottom + window.scrollY + 8 // small offset

  if (notification.entityType === 'PV_MEMO') {
    await fetchPVMemo(notification.appraisalId)
  }

  if (notification.entityType === 'PV') {
    await fetchPaymentVoucher(notification.appraisalId)
  }

  if (notification.entityType === 'MEMO') {
    await fetchMemo(notification.appraisalId)
  }

  if (notification.entityType === 'APPRAISAL') {
    await fetchAppraisal(notification.appraisalId)
  }

  if (notification.entityType === 'BUDGET') {
    await fetchBudget(notification.appraisalId)
  }

  if (notification.entityType === 'SPECIAL_APPROVAL') {
    await fetchSpecialApproval(notification.appraisalId)
  }
}

const hideTooltip = () => {
  tooltipVisible.value = false
}

const getNotifications = async () => {
  const token = Cookies.get('auth_token');
  const entityType = route.params?.entityType ?? route.query?.entityType
  const statusInd = route.params?.statusInd ?? route.query?.statusInd

  let endpoint = `${root_api_url}/notify/notifs/${userId.value}`
  if (entityType !== undefined && entityType !== '' && statusInd !== undefined && statusInd !== '') {
    endpoint = `${endpoint}/${encodeURIComponent(entityType)}/${encodeURIComponent(statusInd)}`
  }

  isLoading.value = true
  try {
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });


    notifications.value = response.data.map(n => {
      // split the path and grab the last element
      const parts = n.targetPath.split('/')
      const appraisalId = parts[parts.length - 1]

      return {
        notificationMsg: n.notificationMsg,
        senderName: n.senderName,
        subject: n.subject,
        ticketStatus: n.ticketStatus,
        ticketTime: n.ticketTime,
        appraisalId,
        targetPath: n.targetPath,
        approvalAuthorityName: n.approvalAuthorityName,
        entityType: n.entityType,
        description: n.description,
        mda: n.mda,
        amount: n.amount,
        amountApproved: n.amountApproved,
        totalBudget: n.totalBudget,
      }
    })
  } catch (error) {
    console.error('Failed to fetch notifications:', error)
  } finally {
    isLoading.value = false
  }
}

const fetchPVMemo = async (id) => {
  const token = Cookies.get('auth_token');
  isLoadingDetails.value = true
  try {
    const { data } = await axios.get(`${root_api_url}/payment/memo/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    hoveredNotification.value = {
      ...hoveredNotification.value,
      ...data
    }
  } catch (error) {
    console.error('Error fetching PV Memo:', error);
  } finally {
    isLoadingDetails.value = false
  }
};

const fetchPaymentVoucher = async (id) => {
  if (!id) {
    return
  }
  isLoadingDetails.value = true
  const token = Cookies.get('auth_token')
  try {
    const { data } = await axios.get(`${root_api_url}/payment/voucher/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    hoveredNotification.value = {
      ...hoveredNotification.value,
      ...data
    }
  } catch (err) {
    console.error('Error fetching Payment Voucher:', err)
    // throw err;
  } finally {
    isLoadingDetails.value = false
  }
}

const fetchMemo = async (id) => {
  const token = Cookies.get('auth_token');
  isLoadingDetails.value = true
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/memo/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    hoveredNotification.value = {
      ...hoveredNotification.value,
      ...data
    }
  } catch (error) {
    console.error('Error fetching Memo:', error);
  } finally {
    isLoadingDetails.value = false
  }
};

const fetchAppraisal = async (id) => {
  const token = Cookies.get('auth_token')
  isLoadingDetails.value = true
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    if (data.natureOfExpenditure == 2) {
      data.natureOfExpenditure = 'Recurrent';
    } else if (data.natureOfExpenditure == 3) {
      data.natureOfExpenditure = 'Capital';
    } else if (data.natureOfExpenditure == 4) {
      data.natureOfExpenditure = 'Hybrid';
    }
    hoveredNotification.value = {
      ...hoveredNotification.value,
      ...data
    }
  } catch (err) {
    console.error('Error fetching Appraisal:', err)
  } finally {
    isLoadingDetails.value = false
  }
}

const fetchBudget = async (id) => {
  if (!id) {
    return
  }
  isLoadingDetails.value = true
  const token = Cookies.get('auth_token');
  try {
    const { data } = await axios.get(`${root_api_url}/eli/mda-eli-budget/budget-upload/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    hoveredNotification.value = {
      ...hoveredNotification.value,
      ...data
    }
  } catch (error) {
    console.error('Failed to fetch Budget:', error)
  } finally {
    isLoadingDetails.value = false
  }
}

const fetchSpecialApproval = async (id) => {
  const token = Cookies.get('auth_token')
  if (!id) {
    return
  }
  isLoadingDetails.value = true
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/special-approval/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    if (data.natOfExpenditure == 2) {
      data.natOfExpenditure = 'Recurrent';
    } else if (data.natOfExpenditure == 3) {
      data.natOfExpenditure = 'Capital';
    } else if (data.natOfExpenditure == 4) {
      data.natOfExpenditure = 'Hybrid';
    }
    hoveredNotification.value = {
      ...hoveredNotification.value,
      ...data
    }
  } catch (error) {
    console.error('Failed to fetch Special Approval:', error)
  } finally {
    isLoadingDetails.value = false
  }
}

/**
const formatDate = (dateString) => {
  const date = new Date(dateString)
  return dayjs.utc(date).format('MMMM D, YYYY h:mma')
}
*/

const formatCurrency = (amount) => {
  return '₦' + Number(amount || 0).toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

const filteredItems = computed(() => {
  const term = debouncedSearch.value.toLowerCase()
  return notifications.value
    .filter(n =>
      n.notificationMsg.toLowerCase().includes(term) ||
      n.senderName.toLowerCase().includes(term) ||
      n.subject.toLowerCase().includes(term) ||
      n.ticketStatus.toLowerCase().includes(term)
    )
    .sort((a, b) => {
      const timeA = new Date(a.ticketTime).getTime() || 0
      const timeB = new Date(b.ticketTime).getTime() || 0
      return timeB - timeA
    })
})

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * pageLength.value
  return filteredItems.value.slice(start, start + pageLength.value)
})

const totalPages = computed(() => {
  return Math.ceil(filteredItems.value.length / pageLength.value)
})

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

const getNotificationRoute = (notification) => {
  const path = notification.targetPath || ''
  const id = notification.appraisalId
  const entityType = route.params?.entityType ?? route.query?.entityType
  const statusInd = route.params?.statusInd ?? route.query?.statusInd
  // const profileRoles = userStore.profile?.role || {}

  // Handle special approval notifications first
  if (path.includes('special-approval')) {
    return { name: 'ViewSpecialApproval', params: { id }, query: { from: 'ViewPendingNotifications' } }
  }

  // Handle pv memo notifications
  if (path.includes('budget')) {
    return { name: 'ViewBudget', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
  }

  // Handle pv memo notifications
  if (path.includes('payment/memo')) {
    return { name: 'ViewPVMemo', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
  }

  // Handle payment voucher notifications
  if (path.includes('payment') || path.includes('voucher') || path.includes('pv')) {
    // If it's an approval notification, go to approval page
    if (path.includes('approval') || path.includes('approve')) {
      return { name: 'ApprovePaymentVoucher', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    }
    // Otherwise go to view page
    return { name: 'ViewPaymentVoucher', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
  }

  // Handle memo notifications
  if (path.includes('memo')) {
    // If it's an approval notification, go to approval page
    if (path.includes('approval') || statusInd === 5) {
      return { name: 'ApproveMemoUpdate', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    }
    // Otherwise go to view page
    return { name: 'ViewMemo', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
  }

  // Handle manual appraisal notifications.
  // A manual appraisal's targetPath is identical to a regular appraisal
  // (/appraisal/appraisal/{id}), so the path alone can't tell them apart —
  // distinguish by the subject / message instead and send it to the
  // manual appraisal page.
  const isManualAppraisal =
    /manual/i.test(notification.subject || '') ||
    /manual/i.test(notification.notificationMsg || '')
  if (path.includes('appraisal') && isManualAppraisal) {
    return { name: 'ViewManualAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
  }

  // Handle appraisal notifications
  if (path.includes('appraisal')) {
    const userStore = useUserStore()
    const userRole = userStore.profile?.role || {};
    if (userRole?.groupHead) {
      return { name: 'UpdateGroupAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    } else if (userRole?.dirOfBudget) {
      return { name: 'UpdateDOBAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    } else if (userRole?.perSec) {
      return { name: 'UpdatePSAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    } else if (userRole?.commOfBAndP) {
      return { name: 'UpdateCommissionerAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    } else if (userRole?.groupMember) {
      return { name: 'UpdateGroupMemberAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    } else {
      return { name: 'ViewAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
    }
  }

  // Default to appraisal
  return { name: 'ViewAppraisal', params: { id }, query: { from: 'ViewPendingNotifications', entityType, statusInd } }
}

const exportToPDF = () => {
  const doc = new jsPDF()
  autoTable(doc, {
    head: [['S/N', 'Notification Message', 'Type', 'Description', 'Balance', 'Ticket Time']],
    body: notifications.value.map((notification, index) => [
      index + 1,
      notification.originatingMda,
      notification.approvalAuthority,
      `₦${notification.amountApproved.toFixed(2)}`,
      `₦${notification.balance.toFixed(2)}`,
      notification.notificationInitiatedDate
    ])
  })
  doc.save('notifications.pdf')
}

const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('users')
  // Add header row
  worksheet.addRow(['S/N', 'Originating MDA', 'Approval Authority', 'Amount Approved', 'Balance', 'Ticket Time'])

  // Add data rows
  notifications.value.forEach((notification, index) => {
    worksheet.addRow([
      index + 1,
      notification.originatingMda,
      notification.approvalAuthority,
      `₦${notification.amountApproved.toFixed(2)}`,
      `₦${notification.balance.toFixed(2)}`,
      notification.notificationInitiatedDate
    ])
  })

  // Style header row (optional)
  worksheet.getRow(1).font = { bold: true }

  // Generate buffer and trigger download
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'users.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)

}



onMounted(() => {
  if (userId.value) {
    getNotifications()
  }

  document.title = "View Notifications"
})



</script>


<style scoped>
.text-center.action .btn {
  background-color: #28A745 !important;
  border: none !important;
  border-radius: 0px !important;
}

.custom-tooltip {
  position: fixed;
  z-index: 9999;
  background: var(--bg);
  color: var(--color);
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 13px;
  max-width: 280px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  animation: fadeIn 0.15s ease-in-out;
}

.custom-tooltip p {
  margin: 0 0 6px;
}

.custom-tooltip p:last-child {
  margin-bottom: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
